import React from 'react';
import { pdfFiles } from '../../body/Pdf';
import { VideoAndShowPDFAfter } from '../../body/VideoSlide';

const IStatments = () => {
  const iStatementsPdf = pdfFiles.strategiesPart2.find(
    (pdf) => pdf.name === '“You” versus “I” Statements',
  );

  return (
    <div className='text-left p-4 space-y-6'>
      <VideoAndShowPDFAfter
        vidSrc={1194426102}
        pdfFile={iStatementsPdf}
      />
    </div>
  );
};

export default IStatments;
